import { c as _c } from "react/compiler-runtime";
import React, { useEffect } from 'react';
import { useEditor, EditorContent } from '@tiptap/react';
import StarterKit from '@tiptap/starter-kit';
import { Placeholder } from '@tiptap/extensions';
import { Box, Paper, useTheme } from '@mui/material';
import EditorToolbar from './EditorToolbar/EditorToolbar';
import Paragraph from '@/components/typography/Paragraph';
const TextEditor = t0 => {
  const $ = _c(49);
  const {
    value,
    onChange,
    error,
    helperText,
    ...props
  } = t0;
  const theme = useTheme();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = StarterKit.configure({
      link: {
        openOnClick: false,
        autolink: true,
        HTMLAttributes: {
          style: "text-decoration: underline;"
        }
      }
    });
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const t2 = Placeholder.configure({
    placeholder: props?.placeholder || "Enter your Return Policy here"
  });
  let t3;
  if ($[1] !== t1 || $[2] !== t2) {
    t3 = [t1, t2];
    $[1] = t1;
    $[2] = t2;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const t4 = value || "";
  let t5;
  if ($[4] !== onChange) {
    t5 = t6 => {
      const {
        editor: e
      } = t6;
      const html = e.isEmpty ? "" : e.getHTML();
      onChange?.(html);
    };
    $[4] = onChange;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== t3 || $[7] !== t4 || $[8] !== t5) {
    t6 = {
      extensions: t3,
      content: t4,
      immediatelyRender: false,
      onUpdate: t5
    };
    $[6] = t3;
    $[7] = t4;
    $[8] = t5;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  const editor = useEditor(t6);
  let t7;
  if ($[10] !== editor || $[11] !== props.disabled || $[12] !== value) {
    t7 = () => {
      if (!editor) {
        return;
      }
      const current = editor.isEmpty ? "" : editor.getHTML();
      if (value !== current && value !== undefined) {
        editor.commands.setContent(value || "", {
          emitUpdate: false
        });
      }
      editor.setEditable(!props?.disabled);
    };
    $[10] = editor;
    $[11] = props.disabled;
    $[12] = value;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  const t8 = props?.disabled;
  let t9;
  if ($[14] !== editor || $[15] !== t8 || $[16] !== value) {
    t9 = [value, editor, t8];
    $[14] = editor;
    $[15] = t8;
    $[16] = value;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  useEffect(t7, t9);
  let t10;
  if ($[18] !== editor?.commands) {
    t10 = () => editor?.commands.focus();
    $[18] = editor?.commands;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  const focusEditor = t10;
  let t11;
  if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = {
      flex: 1
    };
    $[20] = t11;
  } else {
    t11 = $[20];
  }
  let t12;
  if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = {
      borderRadius: 4
    };
    $[21] = t12;
  } else {
    t12 = $[21];
  }
  let t13;
  if ($[22] !== editor) {
    t13 = <EditorToolbar editor={editor} />;
    $[22] = editor;
    $[23] = t13;
  } else {
    t13 = $[23];
  }
  let t14;
  let t15;
  let t16;
  let t17;
  let t18;
  if ($[24] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = {
      outline: "none",
      minHeight: "1em"
    };
    t15 = {
      color: _temp2,
      content: "attr(data-placeholder)",
      float: "left",
      height: 0,
      pointerEvents: "none"
    };
    t16 = {
      margin: 0
    };
    t17 = {
      paddingLeft: "1.5em",
      margin: 0
    };
    t18 = {
      color: "#aaaaaa"
    };
    $[24] = t14;
    $[25] = t15;
    $[26] = t16;
    $[27] = t17;
    $[28] = t18;
  } else {
    t14 = $[24];
    t15 = $[25];
    t16 = $[26];
    t17 = $[27];
    t18 = $[28];
  }
  let t19;
  if ($[29] !== props.sx) {
    t19 = props.sx || {};
    $[29] = props.sx;
    $[30] = t19;
  } else {
    t19 = $[30];
  }
  let t20;
  if ($[31] !== t19) {
    t20 = {
      p: 2,
      pb: 2,
      borderTop: 1,
      borderColor: _temp,
      "& .tiptap": t14,
      "& .tiptap p.is-editor-empty:first-of-type::before": t15,
      "& .tiptap p": t16,
      "& .tiptap ul, & .tiptap ol": t17,
      "& .tiptap[contenteditable=\"false\"]": t18,
      ...t19
    };
    $[31] = t19;
    $[32] = t20;
  } else {
    t20 = $[32];
  }
  let t21;
  if ($[33] !== editor) {
    t21 = <EditorContent editor={editor} />;
    $[33] = editor;
    $[34] = t21;
  } else {
    t21 = $[34];
  }
  let t22;
  if ($[35] !== t20 || $[36] !== t21) {
    t22 = <Box sx={t20}>{t21}</Box>;
    $[35] = t20;
    $[36] = t21;
    $[37] = t22;
  } else {
    t22 = $[37];
  }
  let t23;
  if ($[38] !== t13 || $[39] !== t22) {
    t23 = <Paper variant="outlined" sx={t12}>{t13}{t22}</Paper>;
    $[38] = t13;
    $[39] = t22;
    $[40] = t23;
  } else {
    t23 = $[40];
  }
  let t24;
  if ($[41] !== error || $[42] !== helperText || $[43] !== theme) {
    t24 = !!error && <Box sx={{
      mt: 1,
      ml: 1
    }}><Paragraph sx={{
        fontSize: 14,
        color: theme.palette.primary.main
      }}>{helperText || "This field is required"}</Paragraph></Box>;
    $[41] = error;
    $[42] = helperText;
    $[43] = theme;
    $[44] = t24;
  } else {
    t24 = $[44];
  }
  let t25;
  if ($[45] !== focusEditor || $[46] !== t23 || $[47] !== t24) {
    t25 = <Box onClick={focusEditor} sx={t11}>{t23}{t24}</Box>;
    $[45] = focusEditor;
    $[46] = t23;
    $[47] = t24;
    $[48] = t25;
  } else {
    t25 = $[48];
  }
  return t25;
};
export default TextEditor;
function _temp(t) {
  return t.palette.grey[600];
}
function _temp2(t_0) {
  return t_0.palette.text.disabled;
}